module.exports = __webpack_public_path__ + "img/badge-vr-fill.4da3ff06.svg";